import {EMAIL_MAKER_COMPONENT_TYPES} from '@EmailMakerReact/email-maker-react.constants';
import {makeOptionListControl} from '../../controls/option-list-control/option-list-control';
import {horizontalAlignDescriptor} from '../../controls/option-list-control/option-list-control-descriptors';
import {makeSliderControl} from '../../controls/slider-control/slider-control';
import {borderRadiusDescriptor, heightDescriptor, widthDescriptor} from '../../controls/slider-control/slider-control-descriptors';
import {makeStyleHeader} from '../../controls/style-header/style-header';
import {makeCtaButtonControl} from '../../controls/cta-button-control/cta-button-control';
import {copyPasteStylesDescriptor} from '../../controls/cta-button-control/cta-button-control-descriptors';
import {registerEmailMakerSectorForTypes} from '../../right-panel-registry';
import {TileComplexity} from '@EmailMakerReact/lib/email-maker-tile-meta-library.types';
import {deleteControl, duplicateControl, lockControl} from '../shared/common-action-controls';
import {bgColorControl} from '../shared/color-controls';
import type {EmailMakerControl, EmailMakerSectorProperty} from '../../right-panel-registry.types';

const stylesHeader: EmailMakerControl = makeStyleHeader('pmwjs_styles');

const copyPasteStylesControl = makeCtaButtonControl(copyPasteStylesDescriptor);

const horizontalAlignControl = makeOptionListControl(horizontalAlignDescriptor);

const widthControl = makeSliderControl(widthDescriptor);
const heightControl = makeSliderControl(heightDescriptor);
const borderRadiusControl = makeSliderControl(borderRadiusDescriptor);

const DIVIDER_PROPERTIES: readonly EmailMakerSectorProperty[] = [
  {control: duplicateControl},
  {control: lockControl},
  {control: deleteControl},
  {control: stylesHeader},
  {control: copyPasteStylesControl},
  {control: bgColorControl, tileMeta: {icon: 'icon-fill', labelKey: 'pmwjs_background_color', complexity: TileComplexity.SIMPLE}},
  {control: widthControl, tileMeta: {icon: 'icon-stretch-horizontal', labelKey: 'pmwjs_width', complexity: TileComplexity.SIMPLE}},
  {control: heightControl, tileMeta: {icon: 'icon-stretch-vertical', labelKey: 'pmwjs_height', complexity: TileComplexity.SIMPLE}},
  {control: borderRadiusControl, tileMeta: {icon: 'icon-corner', labelKey: 'pmwjs_roundness', complexity: TileComplexity.COMPLEX}},
  {control: horizontalAlignControl, tileMeta: {icon: 'icon-h-align-center', labelKey: 'pmwjs_horizontal_alignment', complexity: TileComplexity.SIMPLE}},
];

registerEmailMakerSectorForTypes([EMAIL_MAKER_COMPONENT_TYPES.misc.PMW_DIVIDER, EMAIL_MAKER_COMPONENT_TYPES.misc.PMW_DIVIDER_LEGACY], {
  title: window.i18next.t('pmwjs_divider'),
  properties: DIVIDER_PROPERTIES,
});
